module.exports = __webpack_public_path__ + "static/science-of-happiness-a3603709d5f0cb158c2b196b6b640d5c.webp";